import React from "react";
import { Message } from "semantic-ui-react";

const ReassignZendeskTicketDisclaimer = () => (
  <Message
    warning
    icon="warning sign"
    header="Heads up"
    content="Reassigning the Zendesk ticket changes which Zendesk instance and ticket this application is linked to. This may affect notifications, status syncing, and the application flow. Only proceed if you are sure this change is necessary."
    style={{
      backgroundColor: "#FFF8E1",
      color: "#7A4E00",
      border: "1px solid #FFE082",
      boxShadow: "none",
      display: "flex",
    }}
  />
);

export default ReassignZendeskTicketDisclaimer;
